var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"component":"HomeDetail","scene":_vm.scene}},[_c('router-view',{attrs:{"name":"subpage","view":"subpage"}}),_vm._v(" "),_c('div',{attrs:{"block":"main"}},[_vm._t("main")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }